export enum CHECKBOXTYPES {
  CHECKBOX_UNCHECKED = 0,
  CHECKBOX_CHECKED = 1,
  CHECKBOX_INDETERMINATE = 2,
}

export enum ENTITYTYPES {
  ORGANIZATION = 1,
  SUBDIVISION = 2,
}

export interface IAccess {
  id: number;
  access: boolean;
}

export type requestType = {
  organizations: IAccess[];
  subdivisions: IAccess[];
};

export type AccessTree = {
  checkboxType: number;
  children: AccessTree[];
  entityType: number;
  id: number;
  name: string;
};

export type AccessTreeWithParents = {
  checkboxType: number;
  children: AccessTreeWithParents[];
  entityType: number;
  id: number;
  name: string;
  parent: AccessTreeWithParents | null;
};
